import { Navigate } from "react-router-dom";
import useSettingsPermissions from "./hooks/useSettingsPermissions";

export default function SettingsRedirect() {
    const perms = useSettingsPermissions();

    if (perms.canSeeCompanyProfile) return <Navigate to="/settings/company/profile" replace />;
    if (perms.canSeeEmployees) return <Navigate to="/settings/company/employees" replace />;
    return <Navigate to="/settings/account/profile" replace />;
}
